import React from 'react';
import { PreferencesForm } from 'features/tasks-forms';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';

export default function PreferencesPage() {
  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Preferences" />
      </SettingsBreadcrumbs>
      <PreferencesForm />
    </>
  );
}
